import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@benzinga/themetron';
import type { StoryObject } from '@benzinga/basic-news-manager';
import { truncate } from '@benzinga/utils';
import { ProBadge } from '@benzinga/core-ui';
import { useBenzingaEdge } from '@benzinga/edge';

interface WiimProps {
  wiim: Partial<StoryObject> | null;
}

export const Wiim: React.FC<WiimProps> = ({ wiim }) => {
  const { t } = useTranslation('quote');
  const hasBzEdge = useBenzingaEdge().adLightEnabled;

  if (!wiim) return null;

  return (
    <WiimContainer className="wiim-container">
      <div className="wiim-link">
        <span className="wiim-label">
          <span className="mr-1.5">
            <ProBadge variant="blue" />
          </span>
          <span>{t('Quote.WIIM.why-is-it-moving')}:</span>
          <span>{hasBzEdge ? (wiim.title ?? '') : truncate(wiim.title ?? '', 75)}</span>
        </span>
      </div>
    </WiimContainer>
  );
};

const WiimContainer = styled.div`
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colorPalette.gray700};
  width: 100%;

  .wiim-link {
    display: block;
    padding: 8px 12px;
    color: ${({ theme }) => theme.colorPalette.white};
    font-size: 14px;
    line-height: 1.4;
    text-decoration: none;

    &:hover {
      opacity: 0.95;
    }
  }

  .wiim-label {
    font-weight: 700;
    display: inline;

    & > span {
      display: inline-block;
      vertical-align: middle;
    }

    & > span:nth-child(3) {
      font-weight: 400;
      margin-left: 0.25em;
      display: inline;
    }
  }

  @media (max-width: 768px) {
    .wiim-link {
      padding: 6px 10px;
      font-size: 13px;
    }
  }
`;
